"use client";

import { QueryClient, QueryClientProvider, useQueryClient } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { useState } from "react";

export function QueryProvider({ children }: { children: React.ReactNode }) {
  // #region agent log

  // #endregion
  const [queryClient] = useState(
    () => {
      // #region agent log

      // #endregion
      return new QueryClient({
        defaultOptions: {
          queries: {
            // Stale time of 5 minutes
            staleTime: 1000 * 60 * 5,
            // Cache time of 10 minutes
            gcTime: 1000 * 60 * 10,
            // Retry failed requests 3 times
            retry: 3,
            // Retry delay between attempts (default backoff algorithm)
            retryDelay: (attemptIndex: number) => Math.min(1000 * 2 ** attemptIndex, 30000),
            // Refetch on window focus
            refetchOnWindowFocus: true,
            // Don't refetch on reconnect
            refetchOnReconnect: false,
            // Error handling
            throwOnError: false,
          },
          mutations: {
            // Retry failed mutations twice
            retry: 1,
            // Don't throw on mutation errors
            throwOnError: false,
          },
        },
      });
    }
  );


  // #endregion
  return (
    <QueryClientProvider client={queryClient} >
      {/* #region agent log */}
      {/* {(() => { fetch('http://127.0.0.1:7242/ingest/9084fb60-fe4f-4c00-9db2-b5de69b82ffe', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location: 'query-provider.tsx:38', message: 'QueryClientProvider mounted with children', data: { hasChildren: !!children }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'B' }) }).catch(() => { }); return null; })()} */}
      {/* #endregion */}
      {children}
      {process.env.NODE_ENV === "development" && (
        <ReactQueryDevtools
          initialIsOpen={false}
          position="bottom"
          buttonPosition="bottom-left"
        />
      )}
    </QueryClientProvider>
  );
}

export function useCustomQueryClient() {
  const queryClient = useQueryClient();

  return queryClient;
}